import { createAction } from 'typesafe-actions';
import { ITrapEntryComment } from '../../../../types/model/masterData/trap/trapEntryComment';

export default class TrapEntryCommentActions {
    public static setLoading = createAction('MASTER_DATA_TRAP_ENTRY_COMMENT_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
    public static setList = createAction('MASTER_DATA_TRAP_ENTRY_COMMENTS_SET', resolve => (items : Array<ITrapEntryComment>) => resolve(items));
}